class MobileFilterDrawer extends HTMLElement {
  constructor() {
    super();
    this.onOpen = this.open.bind(this);
    this.onClose = this.close.bind(this);
    this.onApply = this.apply.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
  }

  connectedCallback() {
    this.openers = document.querySelectorAll('[data-collection-filters-open]');
    this.closers = this.querySelectorAll('[data-mobile-filter-close]');
    this.applyButton = this.querySelector('[data-mobile-filter-apply]');

    this.openers.forEach((el) => el.addEventListener('click', this.onOpen));
    this.closers.forEach((el) => el.addEventListener('click', this.onClose));
    if (this.applyButton) this.applyButton.addEventListener('click', this.onApply);
    document.addEventListener('keydown', this.onKeydown);

    this.removeAttribute('hidden');
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeydown);
  }

  open() {
    this.classList.add('is-open');
    this.setAttribute('aria-hidden', 'false');
  }

  close() {
    this.classList.remove('is-open');
    this.setAttribute('aria-hidden', 'true');
  }

  apply() {
    // Trigger Dawn's debounced AJAX submit on the filters form, then close.
    const form = this.querySelector('#FacetFiltersForm');
    if (form) {
      form.dispatchEvent(new Event('input', { bubbles: true }));
    }
    this.close();
  }

  onKeydown(event) {
    if (event.key === 'Escape' && this.classList.contains('is-open')) {
      this.close();
    }
  }
}

if (!customElements.get('mobile-filter-drawer')) {
  customElements.define('mobile-filter-drawer', MobileFilterDrawer);
}
